import React from "react";

const InstagramIcon = ({
  width = 24,
  height = 24,
  fill = "white",
  className,
}: {
  fill?: string;
  className?: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_2078_63453)">
        <path
          d="M12 2.16167C15.2063 2.16167 15.5859 2.17573 16.8469 2.23198C18.0188 2.28354 18.6516 2.48042 19.0734 2.64448C19.6313 2.86011 20.0344 3.12261 20.4516 3.53979C20.8734 3.96167 21.1313 4.36011 21.3469 4.91792C21.5109 5.3398 21.7078 5.97729 21.7594 7.14448C21.8156 8.41011 21.8297 8.78979 21.8297 11.9914C21.8297 15.1976 21.8156 15.5773 21.7594 16.8382C21.7078 18.0101 21.5109 18.6429 21.3469 19.0648C21.1313 19.6226 20.8687 20.0257 20.4516 20.4429C20.0297 20.8648 19.6313 21.1226 19.0734 21.3382C18.6516 21.5023 18.0141 21.6992 16.8469 21.7507C15.5813 21.807 15.2016 21.821 12 21.821C8.79375 21.821 8.41406 21.807 7.15313 21.7507C5.98125 21.6992 5.34844 21.5023 4.92656 21.3382C4.36875 21.1226 3.96563 20.8601 3.54844 20.4429C3.12656 20.021 2.86875 19.6226 2.65313 19.0648C2.48906 18.6429 2.29219 18.0054 2.24063 16.8382C2.18438 15.5726 2.17031 15.1929 2.17031 11.9914C2.17031 8.78511 2.18438 8.40542 2.24063 7.14448C2.29219 5.97261 2.48906 5.3398 2.65313 4.91792C2.86875 4.36011 3.13125 3.95698 3.54844 3.53979C3.97031 3.11792 4.36875 2.86011 4.92656 2.64448C5.34844 2.48042 5.98594 2.28354 7.15313 2.23198C8.41406 2.17573 8.79375 2.16167 12 2.16167ZM12 0.000732422C8.74219 0.000732422 8.33438 0.0147949 7.05469 0.0710449C5.77969 0.127295 4.90313 0.333545 4.14375 0.628857C3.35156 0.938232 2.68125 1.34604 2.01563 2.01636C1.34531 2.68198 0.9375 3.3523 0.628125 4.1398C0.332812 4.90386 0.126563 5.77573 0.0703125 7.05073C0.0140625 8.33511 0 8.74292 0 12.0007C0 15.2585 0.0140625 15.6664 0.0703125 16.946C0.126563 18.221 0.332812 19.0976 0.628125 19.857C0.9375 20.6492 1.34531 21.3195 2.01563 21.9851C2.68125 22.6507 3.35156 23.0632 4.13906 23.3679C4.90313 23.6632 5.775 23.8695 7.05 23.9257C8.32969 23.982 8.7375 23.996 11.9953 23.996C15.2531 23.996 15.6609 23.982 16.9406 23.9257C18.2156 23.8695 19.0922 23.6632 19.8516 23.3679C20.6391 23.0632 21.3094 22.6507 21.975 21.9851C22.6406 21.3195 23.0531 20.6492 23.3578 19.8617C23.6531 19.0976 23.8594 18.2257 23.9156 16.9507C23.9719 15.671 23.9859 15.2632 23.9859 12.0054C23.9859 8.74761 23.9719 8.3398 23.9156 7.06011C23.8594 5.78511 23.6531 4.90855 23.3578 4.14917C23.0625 3.35229 22.6547 2.68198 21.9844 2.01636C21.3188 1.35073 20.6484 0.938232 19.8609 0.633545C19.0969 0.338232 18.225 0.131982 16.95 0.0757324C15.6656 0.0147949 15.2578 0.000732422 12 0.000732422Z"
          fill={fill}
        />
        <path
          d="M12 5.83667C8.59688 5.83667 5.83594 8.59761 5.83594 12.0007C5.83594 15.4039 8.59688 18.1648 12 18.1648C15.4031 18.1648 18.1641 15.4039 18.1641 12.0007C18.1641 8.59761 15.4031 5.83667 12 5.83667ZM12 15.9992C9.79219 15.9992 8.00156 14.2085 8.00156 12.0007C8.00156 9.79292 9.79219 8.00229 12 8.00229C14.2078 8.00229 15.9984 9.79292 15.9984 12.0007C15.9984 14.2085 14.2078 15.9992 12 15.9992Z"
          fill={fill}
        />
        <path
          d="M19.8469 5.59287C19.8469 6.38975 19.2 7.03194 18.4078 7.03194C17.6109 7.03194 16.9688 6.38506 16.9688 5.59287C16.9688 4.796 17.6156 4.15381 18.4078 4.15381C19.2 4.15381 19.8469 4.80068 19.8469 5.59287Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_2078_63453">
          <rect width="24" height="24" fill={fill} transform="translate(0 0.000732422)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default InstagramIcon;
